module.exports = __webpack_public_path__ + "img/CSP.31c093af.png";